export default function () {
  let window = `relatorio.leiloes.pagamentoMaior`
  !this.$uloc.window.get(window) && this.$uloc.window.new({
    wid: window,
    title: 'Relação de Pagamentos Feitos a Maior do Leilão',
    width: '600',
    height: '300',
    minHeight: '300px',
    backdrop: false,
    maximize: false,
    clickOutside: false,
    windowClass: 'erp-window',
    contentClass: 'overflow-hidden',
    props: {
    }
  }, () => import('./AnalisePagamentosMaiorLote.vue'))
    .then((wid) => {
      console.log(wid)
    }) // return wid
}
